/** @jsx jsx */
import React from 'react'
import { jsx } from '@emotion/react'
import { useTheme } from '@emotion/react'
import { ImageSourceWithCaptions } from '@news-mono/web-common'
import { GalleryEvent } from '@news-mono/web-common'
import { DataLayerEventName } from '@news-mono/web-common'

import {
    StyledThumbnailSection,
    StyledThumbnailLink,
    StyledThumbnailContainer,
} from '../../../content/Gallery/Gallery.styled'
import { Picture } from '../../../content/Picture/Picture'
import { breakpoint } from '../../../__styling/style-functions'
import { calcRem } from '../../../__styling/style-functions/calc-rem'
import { metrics } from '../../../__styling/settings/metrics'
import { StyledButton } from '../../../buttons/Button/Button.styled'
import { themedValue } from '../../../__styling/themed-value'
import { ResponsivePictureLayout } from '../../../content/Picture/ResponsivePictureLayouts'

export interface GalleryThumbnailsProps {
    images: ImageSourceWithCaptions[]
    onEvent: (event: GalleryEvent) => void
    scrollTo: (imageIndex: number) => void
    toggleThumbnails: () => void
}

export const GalleryThumbnails: React.FC<GalleryThumbnailsProps> = ({
    images,
    onEvent,
    scrollTo,
    toggleThumbnails,
}) => {
    const theme = useTheme()

    return (
        <StyledThumbnailContainer>
            <StyledThumbnailSection>
                {images.map((img, i) => (
                    <StyledThumbnailLink
                        key={i}
                        onClick={() => {
                            onEvent({
                                type: DataLayerEventName.galleryThumbnailClick,
                                originator: 'Gallery',
                                payload: {
                                    imageIndex: i + 1,
                                },
                            })
                            scrollTo(i)
                        }}
                    >
                        <Picture
                            layout={ResponsivePictureLayout.ObjectFitContain}
                            image={img}
                            fixedRatio={img.crops['16:9'] ? '16:9' : 'original'}
                            imageWidths={themedValue(theme, {
                                perthnow: {
                                    mobile: '14vw',
                                    tablet: '16vw',
                                    desktop: '106px',
                                    fallbackWidth: 106,
                                },
                                sevennews: {
                                    mobile: '100vw',
                                    tablet: '50vw',
                                    desktop: '110px',
                                    fallbackWidth: 110,
                                },
                                thewest: {
                                    mobile: '40vw',
                                    tablet: '20vw',
                                    desktop: '110px',
                                    fallbackWidth: 110,
                                },
                            })}
                        />
                    </StyledThumbnailLink>
                ))}
            </StyledThumbnailSection>
            <StyledButton
                onClick={toggleThumbnails}
                css={{
                    margin: `0 auto`,

                    [breakpoint('xs')]: {
                        margin: `0 ${calcRem(
                            metrics.perthnow.margins.lg,
                        )} 0 auto`,
                    },
                }}
            >
                Hide Thumbnails
            </StyledButton>
        </StyledThumbnailContainer>
    )
}
